<div class="contest-tabs__wrapper">
    <h1 class="contest-tabs__title">{{ "contest.list_title" | translate }}</h1>
    <nav mat-tab-nav-bar
         class="contest-tabs__navigation"
         [tabPanel]="tabPanel"
         disablePagination="true">
        <a mat-tab-link
           *ngFor="let tab of matTabs"
           class="contest-tabs__link"
           [routerLink]="tab"
           [active]="isActive(tab)"
           appAriaTitle>{{ 'contest.' + tab | translate }}</a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
    </mat-tab-nav-panel>
</div>